import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';
import './css/fileupload.css';

class PhotoUpload extends Component {
    constructor(Props) {
        super(Props);
        this.state = {
            filePath: ''
        }
    }

    onChange(e) {
        let filePath = '';
        filePath = URL.createObjectURL(e.target.files[0]);
        this.setState({ filePath });
    }


    render() {

        return (
            <div>
                <Form onSubmit="">
                    <Form.Field>
                        <label>Choose file</label>
                        <input
                            type="file"
                            placeholder='Choose a file'
                            name="fileUpload"
                            onChange={this.onChange.bind(this)}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>File Preview</label>
                        <div className="preview-field">
                           
                        </div>
                    </Form.Field>



                    <Form.Field>
                        <Button type="submit">Upload File</Button>
                    </Form.Field>
                </Form>
            </div>
        )
    }
}

export default PhotoUpload;


// WEBPACK FOOTER //
// ./src/HomeComponents/News/PhotoUpload.js